module.exports = __webpack_public_path__ + "img/BYOCS_PhysicalActivity.ee6f70c8.jpg";